import Footer from "@/components/Footer";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#0a0908] text-[#F7F4EE]" data-testid="privacy-page">
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16">
        <span className="av-eyebrow">Documento legale</span>
        <h1 className="font-serif-display text-4xl sm:text-6xl mt-3 leading-[1.05]">
          Informativa sulla{" "}
          <span className="italic text-[#E5A93C]">Privacy</span>
        </h1>
        <p className="text-[#A39E93] mt-4 text-sm">
          Ultimo aggiornamento: 19 settembre 2026 · ai sensi del{" "}
          <strong>Regolamento UE 2016/679 (GDPR)</strong> e del{" "}
          <strong>D.Lgs. 196/2003</strong> come modificato dal D.Lgs. 101/2018.
        </p>

        <a
          href="/api/legal/privacy.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="av-pill av-pill-gold mt-6 inline-flex"
          data-testid="privacy-pdf-btn"
        >
          📄 Scarica PDF stampabile (backup Garante)
        </a>

        <div className="mt-10 space-y-8 text-[#F7F4EE]/90 leading-relaxed">
          <Block n="1" title="Titolare del trattamento">
            <p>
              Il Titolare del trattamento dei dati è <strong>NMA Agency</strong>{" "}
              di Massimiliano Napolitano (di seguito "NMA" o "Titolare").
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1 text-sm">
              <li>Direttore: Massimiliano Napolitano</li>
              <li>Codice Fiscale: <code className="text-[#E5A93C]">NPLMSM74B11F924E</code></li>
              <li>Sede legale: Via Alfredo D'Andrade 5, 10080 Rivara (TO)</li>
              <li>
                Email:{" "}
                <a
                  href="mailto:napolitanomaxagency@live.com"
                  className="text-[#E5A93C] underline"
                >
                  napolitanomaxagency@live.com
                </a>
              </li>
              <li>WhatsApp Business: +39 347 318 8828</li>
            </ul>
            <p className="mt-2 text-sm text-[#A39E93]">
              Il Titolare non è tenuto alla nomina di un DPO (Responsabile della
              Protezione dei Dati) ai sensi dell'art. 37 GDPR; per qualsiasi
              questione privacy è possibile contattare direttamente l'email
              sopra indicata.
            </p>
          </Block>

          <Block n="2" title="Tipologie di dati raccolti">
            <p>
              NMA raccoglie i seguenti dati personali, sempre nel rispetto del
              principio di <em>minimizzazione</em> (art. 5 GDPR):
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1 text-sm">
              <li>
                <strong>Dati di registrazione e contatto</strong>: nome,
                cognome, email, telefono, ente/associazione di appartenenza,
                password (memorizzata in forma cifrata con bcrypt).
              </li>
              <li>
                <strong>Dati relativi alle richieste di preventivo</strong>:
                data e luogo evento, tipologia, budget, note aggiuntive, artisti
                e spettacoli selezionati, cronologia chat con la direzione NMA.
              </li>
              <li>
                <strong>Dati di pagamento</strong>: NMA <em>non</em> conserva
                dati di carta di credito. I pagamenti sono gestiti da{" "}
                <strong>Stripe Inc.</strong> (Titolare autonomo);
                l'applicazione riceve solo l'esito della transazione e l'ID
                sessione.
              </li>
              <li>
                <strong>Dati di navigazione</strong>: indirizzo IP, user-agent
                del browser, referer, pagine visitate, timestamp. Utilizzati in
                forma aggregata per statistiche interne.
              </li>
              <li>
                <strong>File caricati</strong>: immagini profilo, video demo,
                allegati (per artisti che si candidano al roster).
              </li>
            </ul>
            <p className="mt-2 text-sm text-[#A39E93]">
              Non trattiamo <em>categorie particolari di dati</em> (art. 9
              GDPR) né dati di minori sotto i 16 anni.
            </p>
          </Block>

          <Block n="3" title="Finalità e base giuridica">
            <p>I dati sono trattati per le seguenti finalità:</p>
            <div className="overflow-x-auto mt-3">
              <table className="w-full text-sm border-collapse">
                <thead>
                  <tr className="border-b av-hairline text-[#E5A93C]">
                    <th className="text-left py-2 pr-4">Finalità</th>
                    <th className="text-left py-2 pr-4">Base giuridica</th>
                    <th className="text-left py-2">Art. GDPR</th>
                  </tr>
                </thead>
                <tbody className="text-[#F7F4EE]/85">
                  <tr className="border-b av-hairline">
                    <td className="py-2 pr-4">Gestione richieste preventivo e contratti</td>
                    <td className="py-2 pr-4">Esecuzione di un contratto</td>
                    <td className="py-2">6.1.b</td>
                  </tr>
                  <tr className="border-b av-hairline">
                    <td className="py-2 pr-4">Registrazione account e area riservata</td>
                    <td className="py-2 pr-4">Consenso / Contratto</td>
                    <td className="py-2">6.1.a / 6.1.b</td>
                  </tr>
                  <tr className="border-b av-hairline">
                    <td className="py-2 pr-4">Adempimenti fiscali, contabili e SIAE</td>
                    <td className="py-2 pr-4">Obbligo di legge</td>
                    <td className="py-2">6.1.c</td>
                  </tr>
                  <tr className="border-b av-hairline">
                    <td className="py-2 pr-4">Newsletter e comunicazioni promozionali</td>
                    <td className="py-2 pr-4">Consenso revocabile</td>
                    <td className="py-2">6.1.a</td>
                  </tr>
                  <tr className="border-b av-hairline">
                    <td className="py-2 pr-4">Statistiche di navigazione (aggregate)</td>
                    <td className="py-2 pr-4">Legittimo interesse</td>
                    <td className="py-2">6.1.f</td>
                  </tr>
                  <tr>
                    <td className="py-2 pr-4">Tutela in caso di controversie</td>
                    <td className="py-2 pr-4">Legittimo interesse</td>
                    <td className="py-2">6.1.f</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Block>

          <Block n="4" title="Destinatari dei dati">
            <p>
              I dati possono essere comunicati ai seguenti soggetti, nominati{" "}
              <strong>Responsabili del trattamento</strong> ex art. 28 GDPR
              (dove applicabile):
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1 text-sm">
              <li>
                <strong>Stripe Payments Europe Ltd</strong> (Irlanda) — gestione
                pagamenti online.
              </li>
              <li>
                <strong>Fornitore email transazionale</strong> (Resend
                Inc./Emergent) — invio conferme, promemoria e newsletter.
              </li>
              <li>
                <strong>Provider hosting cloud</strong> — infrastruttura,
                storage e database (server localizzati nell'UE ove possibile).
              </li>
              <li>
                <strong>Anthropic / OpenAI / Google</strong> — solo per il
                servizio "Suggerimenti AI Artisti": vengono trasmessi{" "}
                <em>solo il brief evento in forma anonima</em>, mai dati
                personali dell'utente.
              </li>
              <li>
                <strong>Facebook Ireland Ltd, Instagram, YouTube (Google)</strong>{" "}
                — solo se l'utente interagisce con i widget social embed
                presenti in home.
              </li>
              <li>
                Consulenti fiscali e legali del Titolare, in caso di necessità.
              </li>
            </ul>
            <p className="mt-2 text-sm text-[#A39E93]">
              I dati <strong>non sono venduti</strong> a terzi né usati per
              profilazione automatizzata con effetti giuridici (art. 22 GDPR).
            </p>
          </Block>

          <Block n="5" title="Trasferimenti extra-UE">
            <p>
              Alcuni fornitori (Stripe, Anthropic, OpenAI, Google, Meta) possono
              trattare dati in paesi extra-UE (principalmente USA). In tali
              casi il trasferimento avviene sulla base di:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1 text-sm">
              <li>
                <strong>Standard Contractual Clauses (SCC)</strong> approvate
                dalla Commissione Europea (Decisione 2021/914).
              </li>
              <li>
                <strong>EU–US Data Privacy Framework</strong> (Decisione di
                adeguatezza 10/07/2023) per i fornitori aderenti.
              </li>
            </ul>
          </Block>

          <Block n="6" title="Periodo di conservazione">
            <ul className="list-disc pl-6 space-y-1 text-sm">
              <li>Dati account e richieste preventivo: <strong>10 anni</strong> dall'ultima interazione (obblighi contabili).</li>
              <li>Dati di fatturazione: <strong>10 anni</strong> ex art. 2220 c.c.</li>
              <li>Log di navigazione: <strong>massimo 12 mesi</strong>.</li>
              <li>Newsletter: fino a revoca del consenso.</li>
              <li>Candidature artisti non selezionati: <strong>24 mesi</strong>, poi cancellate.</li>
            </ul>
          </Block>

          <Block n="7" title="Diritti dell'interessato">
            <p>
              In qualsiasi momento hai diritto di esercitare, ai sensi degli
              artt. 15-22 GDPR:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1 text-sm">
              <li><strong>Accesso</strong> ai tuoi dati (art. 15)</li>
              <li><strong>Rettifica</strong> di dati inesatti (art. 16)</li>
              <li><strong>Cancellazione / diritto all'oblio</strong> (art. 17)</li>
              <li><strong>Limitazione</strong> del trattamento (art. 18)</li>
              <li><strong>Portabilità</strong> in formato strutturato (art. 20)</li>
              <li><strong>Opposizione</strong> al trattamento per marketing e legittimo interesse (art. 21)</li>
              <li>
                <strong>Revoca del consenso</strong> in qualsiasi momento (senza
                pregiudicare la liceità del trattamento pregresso).
              </li>
              <li>
                <strong>Reclamo</strong> al Garante per la Protezione dei Dati
                Personali (
                <a
                  href="https://www.garanteprivacy.it"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#E5A93C] underline"
                >
                  www.garanteprivacy.it
                </a>
                ) o all'autorità del proprio Stato membro.
              </li>
            </ul>
            <p className="mt-3 text-sm">
              Per esercitare i tuoi diritti scrivi a{" "}
              <a
                href="mailto:napolitanomaxagency@live.com?subject=Richiesta%20esercizio%20diritti%20GDPR"
                className="text-[#E5A93C] underline"
              >
                napolitanomaxagency@live.com
              </a>
              . Risponderemo entro <strong>30 giorni</strong> (art. 12.3 GDPR).
            </p>
          </Block>

          <Block n="8" title="Sicurezza dei dati">
            <p>
              NMA adotta misure tecniche e organizzative adeguate (art. 32
              GDPR):
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1 text-sm">
              <li>Cifratura in transito (HTTPS/TLS 1.3) su tutte le pagine.</li>
              <li>Password utenti cifrate con <strong>bcrypt</strong> a costo 12.</li>
              <li>Autenticazione JWT con scadenza breve.</li>
              <li>Accesso ai dati riservato al solo Titolare e ai fornitori Responsabili.</li>
              <li>Backup periodici cifrati.</li>
            </ul>
          </Block>

          <Block n="9" title="Cookie">
            <p>
              Per informazioni dettagliate sui cookie utilizzati, consulta la{" "}
              <a href="/cookie" className="text-[#E5A93C] underline">
                Cookie Policy
              </a>
              .
            </p>
          </Block>

          <Block n="10" title="Modifiche">
            <p>
              La presente informativa può essere aggiornata. Le versioni
              precedenti restano disponibili su richiesta. In caso di modifiche
              sostanziali, gli utenti registrati verranno avvisati via email.
            </p>
          </Block>
        </div>
      </section>
      <Footer />
    </div>
  );
}

function Block({ n, title, children }) {
  return (
    <section className="border-l-2 border-[#E5A93C]/40 pl-5" data-testid={`privacy-block-${n}`}>
      <h2 className="font-serif-display text-2xl">
        <span className="text-[#E5A93C]/60 mr-2 font-mono text-lg">{n}.</span>
        {title}
      </h2>
      <div className="mt-3 text-sm sm:text-base space-y-2">{children}</div>
    </section>
  );
}
